<script setup>
import CoPaceEventsModal from "@/views/enterprise/home/content/coPace/CoPaceEventsModal.vue";
import {computed, onMounted, ref} from "vue";
import {actualEvents, archivedEvents} from "@/constants/coPaceEvents";
import coPaceService from "@/services/co-pace.service";
import UserWidget from "@/views/enterprise/home/content/coPace/UserWidget.vue";

const events = actualEvents.slice(0, 4);
const coPaceEventsModal = ref(null);
const automotiveGroups = ref([]);

const ventureGroups = computed(() => automotiveGroups.value.filter(group => group.venture));
const controllingGroup = computed(() => automotiveGroups.value.find(group => group.controlling));
const nonVentureGroups = computed(() => automotiveGroups.value.filter(group => !group.venture && !group.controlling));

onMounted(() => {
    getAutomotiveGroups();
})

async function getAutomotiveGroups() {
    const {data} = await coPaceService.getAutomotiveGroups();
    automotiveGroups.value = data;
}
</script>

<template>
    <div class="dashboard--client">
        <div class="card card--bordered">
            <header class="dashboard__header">
                <h3 class="heading3">
                    <img src="@/images/co-pace-logo.png" alt="" />
                </h3>
            </header>

            <ul class="list-cards-inrow list-cards-inrow--in3 mb-0">
                <li>
                    <div class="list-cards-inrow__content">
                        <h5 class="heading5">Upcoming Events</h5>

                        <ul class="list-events">
                            <li v-for="event in events" :key="event.name">
                                <a
                                    v-if="event.url"
                                    :href="event.url"
                                    target="_blank"
                                >
                                    <h6 class="heading6">{{event.name}}</h6>
                                </a>
                                <h6 v-else class="heading6">{{event.name}}</h6>

                                <time class="list-events__date" datetime="">{{event.date}}</time>
                            </li>
                        </ul>

                        <div class="flex-line mt-3" style="justify-content: space-between">
                            <div v-if="archivedEvents.length" class="text-left">
                                <a class="link" @click="coPaceEventsModal.open(true)">Archived Events</a>
                            </div>

                            <div v-if="actualEvents.length > 4" class="text-right">
                                <a class="link" @click="coPaceEventsModal.open()">Next Events</a>
                            </div>
                        </div>

                        <CoPaceEventsModal ref="coPaceEventsModal"/>
                    </div>
                </li>
                <li>
                    <div class="list-cards-inrow__content">
                        <h5 class="heading5">News</h5>

                        <figure class="dashboard--client__news">
                            <figcaption class="dashboard--client__news__figcaption">
                                <a href="https://startupgenome.com/library/big-movers-reshape-the-global-startup-ecosystem-landscape-in-2025" target="_blank"><h6 class="heading6">Big Movers Reshape the Global Startup Ecosystem Landscape in 2025 | Startup Genome</h6></a>
                                <p>Kelly Wolfgang</p>
                            </figcaption>

                            <a class="dashboard--client__news__image" href="https://startupgenome.com/library/big-movers-reshape-the-global-startup-ecosystem-landscape-in-2025" target="_blank">
                                <img src="../../../../../images/global.png" alt="">
                            </a>
                        </figure>

                        <figure class="dashboard--client__news">
                            <figcaption class="dashboard--client__news__figcaption">
                                <a href="https://vivatechnology.com/news/viva-tech-2025-delivers-biggest-edition-yet" target="_blank"><h6 class="heading6">VivaTech 2025 Delivers Biggest Edition Yet</h6></a>
                                <p>Sydney Majors</p>
                            </figcaption>

                            <a class="dashboard--client__news__image" href="https://vivatechnology.com/news/viva-tech-2025-delivers-biggest-edition-yet" target="_blank">
                                <img src="../../../../../images/viva.png" alt="">
                            </a>
                        </figure>

                        <div v-if="false" class="mt-auto text-right">
                            <a class="link">Archived News</a>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="list-cards-inrow__content list-cards-inrow__content--reading">
                        <h5 class="heading5">Reading</h5>

                        <div class="card card--gray flex-row mb-3">
                            <div>
                                <h6 class="heading6">Startup Journeys with Continental</h6>

                                <p class="mb-0">June 2025</p>
                            </div>

                            <a href="/co-pace/Startup%20Journeys.pdf" class="link link--view" download></a>
                        </div>
                        <div class="card card--gray flex-row mb-3">
                            <div>
                                <h6 class="heading6">AI in Manufacturing for Continental</h6>

                                <p class="mb-0">June 4, 2025</p>
                            </div>

                            <a href="/co-pace/AutoTech%20Ventures%20-%20Continental%20Mfg%20AI%20Discussion.pdf" class="link link--view" download></a>
                        </div>
                        <div class="card card--gray flex-row">
                            <div>
                                <h6 class="heading6">Unlocking Competitive Advantage Through Startup Collaboration</h6>

                                <p class="mb-0">May 27, 2025</p>
                            </div>

                            <a href="/co-pace/5StartupCollaborationStrategies.pdf" class="link link--view" download></a>
                        </div>
                        <!-- <div class="mb-3">
                            <a href="/co-pace/co-pace Collaboration Strategies Slides April 2025.pdf" download>
                                <img src="@/images/co-pace-how.png" alt="">
                            </a>
                        </div>
                        <div>
                            <a href="/co-pace/copace service Blueprint.pdf" download>
                                <img src="@/images/co-pace-blueprint.png" alt="">
                            </a>
                        </div> -->
                    </div>
                </li>
            </ul>
        </div>
        <!-- New section -->
        <div class="card card--bordered mt-4">

            <h3 class="heading3 heading3--secondary">Team Setup in Automotive - 2025</h3>

            <div class="community-section">
                <div v-for="group in nonVentureGroups" :key="group.name" class="community-section__col">
                    <div class="card card--gray">
                        <h6 class="heading6 heading6--initial">{{ group.name }}</h6>

                        <ul class="list-community">
                            <UserWidget
                                v-for="(user, index) in group.members"
                                :key="user.id"
                                :user="user"
                                :class="{'list-community__active':index === 0}"
                            />
                        </ul>
                    </div>
                </div>
            </div>

            <div v-if="ventureGroups" class="section-venture">
                <header class="section-venture__header">
                    <span class="section-venture__plate">Venture Client Team & Support</span>
                </header>

                <div class="section-venture__cols">
                    <div>
                        <ul v-for="(group, index) in ventureGroups" :key="index" class="list-community">
                            <UserWidget
                                v-for="user in group.members"
                                :key="user.id"
                                :user="user"
                            />
                        </ul>
                    </div>

                    <div v-if="controllingGroup">
                        <ul class="list-community">
                            <UserWidget
                                v-for="user in controllingGroup.members"
                                :key="user.id"
                                :user="user"
                                location="Controlling"
                            />
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!--  -->

    </div>
</template>

<style scoped>

</style>
